import {
  Injectable,
  ApplicationRef,
  ComponentRef,
  EnvironmentInjector,
  createComponent,
  inject,
  PLATFORM_ID
} from '@angular/core';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { LoadingOverlayComponent } from './loading-overlay.component';

@Injectable({ providedIn: 'root' })
export class LoadingOverlayService {
  private overlayRef: ComponentRef<LoadingOverlayComponent> | null = null;
  private appRef = inject(ApplicationRef);
  private environmentInjector = inject(EnvironmentInjector);
  private doc = inject(DOCUMENT);
  private platformId = inject(PLATFORM_ID);

  show(message: string = 'Saving your progress...') {
    if (!isPlatformBrowser(this.platformId)) return;

    if (!this.overlayRef) {
      this.overlayRef = createComponent(LoadingOverlayComponent, {
        environmentInjector: this.environmentInjector,
      });
      this.appRef.attachView(this.overlayRef.hostView);
      this.doc.body.appendChild(this.overlayRef.location.nativeElement);
    }
    this.overlayRef.instance.show(message);
  }

  hide() {
    if (!isPlatformBrowser(this.platformId)) return;

    if (this.overlayRef) {
      this.overlayRef.instance.hide();
      // Optional: tear it down after transition
      setTimeout(() => {
        if (this.overlayRef) {
          this.appRef.detachView(this.overlayRef.hostView);
          this.overlayRef.destroy();
          this.overlayRef = null;
        }
      }, 400); // Wait for the CSS transition
    }
  }
}
